import type {NamedSetState} from 'app/gemStore/devtools';

import type {MediaInnerHeightSlice} from './types';

export const createMediaInnerHeightSlice = (set: NamedSetState<MediaInnerHeightSlice>) => ({
    mediaInnerHeight: typeof window !== 'undefined' ? window.innerHeight : 0,
    setMediaInnerHeight: (mediaInnerHeight: number) => set({mediaInnerHeight}, false, 'mediaInnerHeight/setMediaInnerHeight'),
});
